import { render, staticRenderFns } from "./addtypeActivities.vue?vue&type=template&id=5426790d&scoped=true&"
import script from "./addtypeActivities.vue?vue&type=script&lang=js&"
export * from "./addtypeActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5426790d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5426790d')) {
      api.createRecord('5426790d', component.options)
    } else {
      api.reload('5426790d', component.options)
    }
    module.hot.accept("./addtypeActivities.vue?vue&type=template&id=5426790d&scoped=true&", function () {
      api.rerender('5426790d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/activities/components/components/addtypeActivities.vue"
export default component.exports